var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSms1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.6668 68.3333H23.3334C13.3334 68.3333 6.66675 63.3333 6.66675 51.6666V28.3333C6.66675 16.6666 13.3334 11.6666 23.3334 11.6666H56.6668C66.6668 11.6666 73.3334 16.6666 73.3334 28.3333V51.6666C73.3334 63.3333 66.6668 68.3333 56.6668 68.3333Z",
    stroke: "#45B14A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6666 30L46.2332 38.3333C42.7999 41.0667 37.1666 41.0667 33.7332 38.3333L23.3333 30",
    stroke: "#276E91",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms1);
export default __webpack_public_path__ + "static/media/sms1.5dd7ca93672d446318230e0eae8ad494.svg";
export { ForwardRef as ReactComponent };